/**
 * calculate the duration of the scroll animation based on the width of the banner and text
 */
import * as $ from 'jquery';

export function updateScrollAnimation() {
	const banner = document.querySelector<HTMLElement>('.scroll-banner');
	const text = document.querySelector<HTMLElement>('.scroll-text');

	if (banner && text) {
		const bannerWidth = banner.offsetWidth;
		const textWidth = text.offsetWidth;

		const endPosition = -(textWidth + bannerWidth);

		text.style.animation = `scrollText 30s linear infinite`;
		text.style.transform = `translateX(${bannerWidth}px)`;

		const style = document.createElement('style');
		style.innerHTML = `
  @keyframes scrollText {
    from { transform: translateX(${bannerWidth / 10}px); }
    to { transform: translateX(${endPosition}px); }
  }`;
		document.head.appendChild(style);
	}
	
}

$('.site-wide-banner .white-button__icon').on('click', function () {	
	$(this).parents('.site-wide-banner').remove();
})
